class outSystemCtrl {
    constructor($rootScope, $scope) {
        // 初始化表单数据
        // 用户信息
        const { userInfo } = $rootScope
        // 存储页面信息
        $scope.pageState = {
            idToken: $rootScope.idToken,
            userInfo,
            system: {},
            addflag: true, // 判断是新增还是编辑的标识
        }
    }
}

outSystemCtrl.$inject = ['$rootScope', '$scope']
export default outSystemCtrl



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/outsystem/outSystemCtrl.js